<script setup>
import LoadingWidget from './LoadingWidget'

import { ref } from 'vue'

//import {  } from './composables/button'
//TODO allow customizable click/enter event names/data
  

const { id, size, type, label, name } = defineProps({
  id: String,
  size: { // btn-small, btn-med, btn-large, btn-square, btn-full-width
    type: String,
    default: 'btn-med',
  },
  type: { // outline, solid, danger
    type: String,
    default: 'solid'
  },
  label: {
    type: String,
    default: 'Click',
  },
  name: {
    type: String,
    default: 'btn'
  },
  cssClasses: {
    type: String,
  },
})

const circleSize = {width: '16px', height: '16px'}
const loading = ref(false)

const toggleSpinner = (show = false) => {
  loading.value = show
}

defineExpose({ toggleSpinner })

</script>

<template>
  <div class="btn-cont" :class="[size, cssClasses]" :id="id">
    <button 
      class="btn" 
      :class="type"
      @click="$emit('btn-click')"
      @keyup.enter="$emit('keyup-enter')">
      <span 
        class="flex justify-center align-center"
        ref="labelText"
        v-html="label"
        v-show="!loading">
      </span>

      <LoadingWidget
        v-show="loading"
        class=""
        ref="spinner"
        type="circle"
        :size="circleSize"
        cssClasses="small">
      </LoadingWidget>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.btn-cont {
  .btn {
    padding: $paddingSmall $paddingMed;
    border: 2px solid color(primary-container);
    border-radius: $borderRadius;
    font-weight: 500;
    font-size: $font;
    cursor: pointer;

    &:active {
      background-color: color(primary);
      color: color(on-primary);
    }

    &.solid {
      background-color: color(primary-container);
      color: color(on-primary-container);
      
      &:hover {
        background-color: color(surface);
        color: color(primary);
      }
    }

    &.outline {
      background-color: inherit;
      color: color(primary-container);

      &:hover {
        background-color: color(primary-container);
        color: inherit;
      }
    }
  
    &.danger {
      border-color: color(error);
      background-color: color(error);

      &:hover {
        background-color: color(surface);
        color: color(error);
      }

      &:active {
        background-color: color(error);
        color: color(on-surface);
      }
    }

    &.invisible {
      border: none;
      background-color: inherit;
      color: color(primary);
      width: auto !important;
      padding: 0 !important;

      &:hover {
        background-color: color(surface);
        color: color(primary);
      }

      &.danger {
        color: color(error);

        &:hover {
          color: color(error);
        }

        &:active {
          color: color(error);
        }
      }
    }
  }

  &.btn-full-width {
    .btn {
      width: 100%;
      margin: 0;
    }
  }

  &.btn-small {
    .btn {
      padding: $paddingXSmall $padding;
      width: 75px;
    }
  }

  &.btn-med {
    .btn {
      width: 100px;
    }
  }

  &.btn-large {
    .btn {
      //padding: $paddingMed $paddingLarge;
      width: 140px;
    }
  }

  &.btn-square {
    .btn {
      padding: $padding;
    }
  }
}
</style>
